import { useState } from "react";
import { Box, Button, Grid, Stack, Typography } from "@mui/material";

import { useDispatch, useSelector } from "react-redux";

import { RootState } from "@store/store";
import { setDialogConfig } from "@store/slices/componentsSlice";

import OkCheck from "@assets/OkCheck.svg";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";

export interface ValidarProps {
    type: "VISIT" | "COMPLETE" | "VALIDATE_DOC" | "VALIDATE_EXP" | "DELETE_DOC" | "REGENERAR_DOC" | "CONFIRM_ACTION";
    date?: string;
    time?: string;
    title: string;
    subtitle?: string;
    isProcessing?: boolean;
    showApplicationInfo?: boolean;
    onBackClick: () => void;
    onContinueClick: () => void;
}

export const Validar = (props: ValidarProps) => {
    const dispatch = useDispatch();

    const [isProcessing, setIsProcessing] = useState<boolean>(false);

    const applicationSelected = useSelector((state: RootState) => state.components.applicationSelected);

    const showApplicationInfo = props.showApplicationInfo === undefined ? true : props.showApplicationInfo;

    const handleOnBackClicked = () => {
        dispatch(setDialogConfig());
        props.onBackClick();
    };

    const handleOnContinueClicked = () => {
        switch (props.type) {
            case "VISIT":
                setIsProcessing(true);
                props.onContinueClick();
                break;
            case "VALIDATE_DOC":
                setIsProcessing(true);
                props.onContinueClick();
                break;
            case "VALIDATE_EXP":
                setIsProcessing(true);
                props.onContinueClick();
                break;
            case "COMPLETE":
                setIsProcessing(true);
                props.onContinueClick();
                break;
            case "DELETE_DOC":
                setIsProcessing(true);
                props.onContinueClick();
                break;
            case "REGENERAR_DOC":
                setIsProcessing(true);
                props.onContinueClick();
                break;
            case "CONFIRM_ACTION":
                setIsProcessing(true);
                props.onContinueClick();
                break;
        }
    };

    return (
        <Box margin={4}>
            <Stack textAlign={"center"} spacing={2}>
                {props.type === "DELETE_DOC" && (
                    <HighlightOffIcon sx={{ alignSelf: "center", fontSize: 80, color: "#E35050" }} />
                )}
                {props.type === "REGENERAR_DOC" && (
                    <WarningAmberIcon sx={{ alignSelf: "center", fontSize: 80, color: "#F79E18" }} />
                )}
                {props.type === "CONFIRM_ACTION" && (
                    <HelpOutlineIcon sx={{ alignSelf: "center", fontSize: 80, color: "#F79E18" }} />
                )}

                {props.type !== "DELETE_DOC" && props.type !== "REGENERAR_DOC" && props.type !== "CONFIRM_ACTION" && (
                    <img src={OkCheck} height={"65px"} />
                )}

                <Typography variant="body1" fontWeight={600}>
                    {props.title}
                </Typography>
                {showApplicationInfo && (
                    <>
                        <Typography variant="body1" fontWeight={600} color="#528CD6">
                            {applicationSelected.comercial_name}
                        </Typography>
                        <Typography variant="h4">
                            ID SOLICITUD:{" "}
                            <Typography component={"span"} variant="h4" fontWeight={600}>
                                {applicationSelected.id_application_company}
                            </Typography>
                        </Typography>
                    </>
                )}
                {props.type === "VISIT" && (
                    <>
                        <Typography variant="body1" fontWeight={400}>
                            El día y la hora:
                        </Typography>
                        <Typography variant="body1" fontWeight={600} color="#528CD6">
                            {props.date} de {props.time}:00 a {Number(props.time) + 1}:00
                        </Typography>
                    </>
                )}

                {props.type === "COMPLETE" && <></>}

                <Stack direction={"row"} justifyContent={"space-around"} pt={6}>
                    <Button variant={"blue_outlined"} onClick={handleOnBackClicked} disabled={isProcessing}>
                        Regresar
                    </Button>
                    <Button
                        variant={"contained"}
                        type="submit"
                        loading={isProcessing}
                        disabled={isProcessing}
                        onClick={handleOnContinueClicked}
                    >
                        Continuar
                    </Button>
                </Stack>
            </Stack>
        </Box>
    );
};
